import { common } from "@shared/constants";
import { useMemo } from "react";
import { useSeatingState } from "../../contexts/useSeatingState";
import { ItemSelectVerbiageProps } from "./ItemSelectVerbiage.props";

export function useItemSelectVerbiage(props: ItemSelectVerbiageProps) {
  const { item } = props;
  const { seatingServiceState } = useSeatingState();
  const { mapItemType } = seatingServiceState;

  const isGroupSale = useMemo(
    () => seatingServiceState.isGroupSalesMap(),
    [seatingServiceState]
  );
  const isDynamicHold = useMemo(
    () => Boolean(seatingServiceState.basketHoldID),
    [seatingServiceState]
  );

  const isSoldOut = useMemo(
    () =>
      (item?.usageRemaining === 0 || item?.sold_out) &&
      !isGroupSale &&
      !isDynamicHold,
    [item, isGroupSale, isDynamicHold]
  );

  const hasPaymentPlans = useMemo(
    () =>
      item.has_payment_plans ||
      (item.payment_plans && item.payment_plans.length > 0),
    [item]
  );

  const showPaymentVerbiage = useMemo(
    () => mapItemType !== common.SeatingMapItemType.MEMBERSHIP,
    [mapItemType]
  );

  const showPasswordInput = useMemo(
    () =>
      !isSoldOut &&
      mapItemType !== common.SeatingMapItemType.MEMBERSHIP &&
      !isGroupSale,
    [isSoldOut, mapItemType, isGroupSale]
  );

  return { isSoldOut, hasPaymentPlans, showPaymentVerbiage, showPasswordInput };
}
